import Vue from "vue";
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import VeeInput from "./VeeInput";
import VeeTextarea from "./VeeTextarea";
import VeeButton from "./VeeButton";
import * as rules from 'vee-validate/dist/rules';
import ru from 'vee-validate/dist/locale/ru.json';
import VeeFieldset from "./VeeFieldset";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
localize( 'ru', ru);

extend('validJson', {
    getMessage: field => 'The' + field + ' value is not valid json',
    validate: (value) => {
        try {
            JSON.parse(value);
        } catch (e) {
            return false;
        }
        return true;
    }
})

Vue.component('vee-input', VeeInput);
Vue.component('vee-textarea', VeeTextarea);
Vue.component('vee-button', VeeButton);
Vue.component('vee-fieldset', VeeFieldset);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


extend('email', {
    params: {
        name: 'multiple',
        default: false
    },
    validate: function (value, _a) {
        var multiple = (_a === void 0 ? {} : _a).multiple;
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/;
        if (multiple && !Array.isArray(value)) {
            value = String(value)
              .split(',')
              .map(function (emailStr) { return emailStr.trim(); });
        }
        if (Array.isArray(value)) {
            return value.every(function (val) { return re.test(String(val)); });
        }
        return re.test(String(value));
    }
});

extend('clinicAnyOfEight', {
    params: ['website','socialVk','socialFb', 'socialInsta','socialOk', 'socialYoutube', 'socialTg', 'socialWhatsApp', 'proprietary'],
    validate: (value, { website, socialVk,socialFb, socialInsta, socialOk, socialYoutube, socialTg, socialWhatsApp, proprietary }) => {
        if (proprietary === "private") {
            if (website === '' &&
                socialVk === '' &&
                socialFb === '' &&
                socialOk === '' &&
                socialInsta === '' &&
                socialYoutube === '' &&
                socialTg === '' &&
                socialWhatsApp === ''
            ) {
                return false;
            }
        }
        return true;
    },
    computesRequired: true,
    message:
        "Должно быть заполнено хотя бы одно поле из (Официальный сайт, Страница ВК/Instagram/Facebook/Ok/Youtube/Tg/WhatsApp)"
});
extend('clinicAnyOfSix', {
    params: ['website', 'socialVk', 'socialOk', 'socialYoutube', 'socialTg', 'socialWhatsApp', 'proprietary'],
    validate: (value, { website, socialVk, socialOk, socialYoutube, socialTg, socialWhatsApp, proprietary }) => {
        if (proprietary === "private") {
            if (website === '' &&
                socialVk === '' &&
                socialOk === '' &&
                socialYoutube === '' &&
                socialTg === '' &&
                socialWhatsApp === ''
            ) {
                return false;
            }
        }
        return true;
    },
    computesRequired: true,
    message:
        "Должно быть заполнено хотя бы одно поле из (Официальный сайт, Страница ВК/Ok/YouTube/Tg/WhatsApp)"
});
extend('codeNMY', {
    validate: (value) => {
        let regEx = /^[АA]\d{2}.\d{2}(.\d{3}){1,2}$|^[BВ]\d{2}.(\d{3}\.){1,3}\d{2,3}$/;
            if (value === '' || value ===undefined || regEx.test(value)) {
                return true;
            }
        return false;
    },
    computesRequired: true,
    message: "Не соответствует номенклатуре медицинских услуг!"
});
extend('hyphenBeginEnd', {
    validate: (value) => {

            if (value !== '' && value !==undefined ) {
                if (value[0]==='-' || value.toString().slice(-1)==='-')
                return false;
            }
        return true;
    },
    computesRequired: true,
    message: "Не должно начинаться или заканчиваться на «-»"
});
extend('clinicAnyOfEightMod', {
    validate: () => {
        return false
    },
    computesRequired: true,
    message: "Должно быть заполнено хотя бы одно поле из (Официальный сайт, Страница ВК/Instagram/Facebook/Ok/Tg/WhatsApp)"
});
extend('clinicAnyOfSixMod', {
    validate: () => {
        return false
    },
    computesRequired: true,
    message: "Должно быть заполнено хотя бы одно поле из (Официальный сайт, Страница ВК/Ok/YouTube/Tg/WhatsApp)"
});
extend('urlAvailable', value => {
    return 'url занято!';
});
extend('url', value => {
    const httpRegex = new RegExp(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/)
    if (value.match(httpRegex)) {
        return true;
    }
    return 'url некорректный';
});
extend('loginNotAvailable', value => {
    return 'Пользователь с таким именем уже существует, попробуйте другое!';
});
extend('requiredPermissions', {
    validate(value) {
        return {
            required: true,
            valid: value === true
        };
    },
    computesRequired: true,
    message: 'Нельзя создавать бесправного пользователя!'
});
// extend('requiredPermissions', value => {
//     return 'Нельзя создавать бесправного раба!';
// });
extend('clinicTypes', value => {
    if (value.length>5){
        return 'Должно быть выбрано не более 5 категорий'
    }
    return true;
});
extend('socialVk', value => {
    if (value.indexOf('vk.com') === -1) {
        return 'Указана некорректная соцсеть';
    }
    return true;
});
extend('socialYoutube', value => {
    if ( value.indexOf('youtube.com') === -1) {
        return 'Указана некорректная ссылка на канал';
    }
    return true;
});
extend('socialFb', value => {
    if (value.indexOf('facebook.com') === -1) {
        return 'Указана некорректная соцсеть';
    }
    return true;
});
extend('socialInsta', value => {
    if ( value.indexOf('instagram') === -1) {
        return 'Указана некорректная соцсеть';
    }
    return true;
});
extend('socialOk', value => {

    if (value.indexOf('ok.ru') === -1) {
        return 'Указана некорректная соцсеть';
    }
    return true;
});
extend('socialTg', value => {
    if (value.indexOf('t.me') === -1) {
        return 'Указана некорректная соцсеть';
    }
    return true;
});
extend('required',  {
    message: 'Поле обязательно для заполнения!'
});

extend('phone',  value => {
    const phoneRegex = new RegExp(/^[\+]?[0-9]{1}[-\s\.]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im)
    if (value.match(phoneRegex)) {
        return true
    }

    return 'Некорректный номер телефона';
});
